import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeftIcon } from 'components/icons';
import Skeleton from '../skeleton/Skeleton';
import styles from './spinDetails.module.scss';
import { formatLocalTime } from 'utils/formatDate';
import cx from 'classnames';

interface TipReceivedDetailsProps {
  details: any;
  onBack: () => void;
  isLoading?: boolean;
  title?: string | null;
}

const TipReceivedDetails: React.FC<TipReceivedDetailsProps> = ({
  details,
  title,
  onBack,
  isLoading,
}) => {
  const { t } = useTranslation();
  const [isFadingOut, setIsFadingOut] = React.useState(false);

  const handleBack = () => {
    setIsFadingOut(true);
    setTimeout(() => {
      onBack();
    }, 200);
  };

  return (
    <div className={cx(styles.container, { [styles.fadingOut]: isFadingOut })}>
      <button className={styles.backButton} onClick={handleBack} aria-label="Go back">
        <ChevronLeftIcon width="20" height="20" />
      </button>

      <div className={styles.header}>
        <h2>{isLoading ? <Skeleton width={180} height={24} /> : title || 'Tip Received'}</h2>
      </div>

      <div className={styles.statsList}>
        <div className={styles.statRowCard}>
          <span className={styles.statLabel}>{t('notifications.labels.from', 'From')}</span>
          {isLoading || !details ? (
            <Skeleton width={80} height={20} />
          ) : (
            <span className={styles.statValue}>{details.senderUsername || '-'}</span>
          )}
        </div>
        <div className={styles.statRowCard}>
          <span className={styles.statLabel}>{t('notifications.labels.amount', 'Amount')}</span>
          {isLoading || !details ? (
            <Skeleton width={60} height={20} />
          ) : (
            <span className={styles.statValue}>
              {details.amount !== undefined ? `$${Number(details.amount).toFixed(2)}` : '-'}
            </span>
          )}
        </div>
        <div className={styles.statRowCard}>
          <span className={styles.statLabel}>{t('notifications.labels.currency', 'Currency')}</span>
          {isLoading || !details ? (
            <Skeleton width={40} height={20} />
          ) : (
            <span className={styles.statValue}>{details.currencyCode || 'USD'}</span>
          )}
        </div>
      </div>

      <div className={styles.validUntil}>
        {isLoading || !details ? (
          <Skeleton width={160} height={16} />
        ) : details.createdAt ? (
          <span>
            {t('notifications.labels.receivedOn', {
              date: formatLocalTime(details.createdAt, false),
            })}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default TipReceivedDetails;
